import { newrelic } from "@jti/fe-clients";
import { getConfig, getLocale } from "@jti/fe-common";

import type { YandexApiResponse, YandexSuggestion } from "./YandexApiTypes";

export class YandexApi {
  readonly name = "YandexApi";

  static init(): YandexApi {
    return new YandexApi();
  }

  async getSuggestions(query: string): Promise<YandexSuggestion[]> {
    try {
      const locale = getLocale();
      const { autocompleteProviderApiUrl } = getConfig();

      const url = new URL(autocompleteProviderApiUrl);
      const queryParams = new URLSearchParams({
        text: query,
        print_address: "1",
        lang: locale,
        results: "5",
      });
      queryParams.forEach((value, key) => {
        url.searchParams.set(key, value);
      });

      const response = await fetch(url.toString());
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data: YandexApiResponse = await response.json();
      return data.results ?? [];
    } catch (error) {
      const errorObject = error instanceof Error ? error : new Error(String(error));
      console.error("Error fetching Yandex suggestions:", errorObject);
      newrelic.noticeError(errorObject);
      return [];
    }
  }
}
